import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import PatientTypeApi from 'api/setting/default-users/patient-type.api'

/** UTILS || SLICE */
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Divider, Grid, InputAdornment, Typography } from '@mui/material'
import OperativeTypeApi from 'api/setting/treatments/operative-type.api'
import OperativeApi from 'api/setting/treatments/operative.api'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { colors } from 'constants/theme'
import _ from 'lodash'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  PATIENT_TYPE_NAME: ``,
  IS_DUPLICATE_PATIENT_TYPE_NAME: ``,
  PATIENT_TYPE_NAME_STRING_BASE: ``,
  PATIENT_TYPE_NAME_STRING_EMPTY: ``,
  PATIENT_TYPE_NAME_MAXIMUM_LENGTH: ``,
  PATIENT_TYPE_NAME_ANY_REQUIRED: ``,

  PATIENT_TYPE_NAME_EN: ``,
  IS_DUPLICATE_PATIENT_TYPE_NAME_EN: ``,
  PATIENT_TYPE_NAME_EN_STRING_BASE: ``,
  PATIENT_TYPE_NAME_EN_STRING_EMPTY: ``,
  PATIENT_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  PATIENT_TYPE_NAME_EN_ANY_REQUIRED: ``,

  OPERATIVE_TYPE: "",
  OPERATIVE: "",
  VISITCOUNT: "",
}
export default function PatientTypes() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [patientTypes, setPatientTypes] = useState([])

  const [patientTypeId, setPatientTypeId] = useState(Number)
  const [patientTypeName, setPatientTypeName] = useState('')
  const [patientTypeNameEn, setPatientTypeNameEn] = useState('')
  const [patientTypeStatus, setPatientTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isPopup, setIsPopup] = useState(false)
  const [hasCondition, setHasCondition] = useState('0')
  const [operativeTypes, setOperativeTypes] = useState([])
  const [operative, setOperative] = useState([])
  const [dataOperativeTypes, setDataOperativeTypes] = useState('')
  const [dataOperative, setDataOperative] = useState('')
  const [visitCount, setVisitCount] = useState<any>(null)
  const [conditions, setConditions] = useState('ALL')


  const loadData = async () => {
    try {
      let condition: any = {}
      if (page) condition = { ...condition, page: page }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (search) condition = { ...condition, search: search }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (sortType) condition = { ...condition, sortType: sortType }
      if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }
      if (conditions) condition = { ...condition, hasCondition: conditions }

      const res = await PatientTypeApi.findAll(condition)
      if (res.status === 200) {
        setRowCount(res.headers['x-total'])
        setPatientTypes(res.data)
      }
    } catch (error) {
      notiError('ERROR')
    }
  }



  const loadOperativeType = useCallback(async () => {
    const resp = await OperativeTypeApi.findAll({ pageLimit: 999, status: 'ACTIVE' })
    if (resp.status === 200) {
      setOperativeTypes(resp.data)
    } else {
      setOperativeTypes([])
    }
  }, [])

  const loadOperative = async (id: number) => {
    const resp = await OperativeApi.findAll({ operativeTypeId: id, pageLimit: 999, status: 'ACTIVE' })
    if (resp.status === 200) {
      setOperative(resp.data)
    } else {
      setOperative([])
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  useEffect(() => {
    loadOperativeType()
  }, [])

  const submit = () => {
    if (hasCondition === "1") {
      if (!patientTypeName || !dataOperativeTypes || !dataOperative || !visitCount || visitCount === '0' || visitCount === 0) {
        return setErrorMessage({
          ...errorMessage, ...{
            PATIENT_TYPE_NAME: !patientTypeName ? t('PATIENT_TYPE.MESSAGE.PATIENT_TYPE_NAME') : '',
            OPERATIVE_TYPE: hasCondition === "1" ? !dataOperativeTypes ? 'กรุณาเลือก ประเภทหัตถการ' : '' : '',
            OPERATIVE: hasCondition === "1" ? dataOperativeTypes ? !dataOperative ? 'กรุณาเลือก รายการหัตถการ' : '' : '' : "",
            VISITCOUNT: hasCondition === '1' ? dataOperative ? (!visitCount || visitCount === "0" || visitCount === 0) ? "กรุณากรอกจำนวน" : "" : "" : ""
          }
        })
      }
    }
    dispatch(submitModal())
    setDisabledSubmit(true)
    PatientTypeApi.create({
      patientTypeName: patientTypeName,
      patientTypeNameEn: patientTypeNameEn,
      hasCondition: hasCondition,
      itemId: Number(dataOperative),
      itemTypeId: Number(dataOperativeTypes),
      visitCount: Number(visitCount)
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('PATIENT_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()

          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (hasCondition === "1") {
      if (!patientTypeName || !dataOperativeTypes || !dataOperative || !visitCount || visitCount === '0' || visitCount === 0) {
        return setErrorMessage({
          ...errorMessage, ...{
            PATIENT_TYPE_NAME: !patientTypeName ? t('PATIENT_TYPE.MESSAGE.PATIENT_TYPE_NAME') : '',
            OPERATIVE_TYPE: hasCondition === "1" ? !dataOperativeTypes ? 'กรุณาเลือก ประเภทหัตถการ' : '' : '',
            OPERATIVE: hasCondition === "1" ? dataOperativeTypes ? !dataOperative ? 'กรุณาเลือก รายการหัตถการ' : '' : '' : "",
            VISITCOUNT: hasCondition === '1' ? dataOperative ? (!visitCount || visitCount === '0' || visitCount === 0) ? "กรุณากรอกจำนวน" : "" : "" : ""
          }
        })
      }
    }

    dispatch(submitModal())
    setDisabledSubmit(true)
    PatientTypeApi.update(patientTypeId, {
      patientTypeName: patientTypeName,
      patientTypeNameEn: patientTypeNameEn,
      hasCondition: hasCondition,
      itemId: Number(dataOperative),
      itemTypeId: Number(dataOperativeTypes),
      visitCount: Number(visitCount),
      status: patientTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`PATIENT_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data

          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setPatientTypeId(0)
    setPatientTypeName('')
    setPatientTypeNameEn('')
    setPatientTypeStatus('')
    setHasCondition('0')
    setDataOperative('')
    setDataOperativeTypes('')
    setVisitCount(null)
    setIsPopup(false)
    clearErrorMessage()
  }

  const onActive = () => {
    if (id) {
      PatientTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      PatientTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { patientTypeId: ptTypeId, patientTypeName: ptTypeName, patientTypeNameEn: ptTypeNameEn, status: ptTypeStatus } = data
    setPatientTypeId(ptTypeId)
    setPatientTypeName(ptTypeName)
    setPatientTypeNameEn(ptTypeNameEn)
    setPatientTypeStatus(ptTypeStatus)
    setDataOperativeTypes(data.itemTypeId)
    setDataOperative(data.itemId)
    setVisitCount(data.visitCount)
    setHasCondition(data.hasCondition)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'patientTypeName', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.PATIENT_TYPE_NAME') },
    { id: 'patientTypeNameEn', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.PATIENT_TYPE_NAME_EN') },
    { id: 'condition', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.CONDITION') },
    { id: 'status', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { patientTypeId: ptTypeId, patientTypeName: ptTypeName, patientTypeNameEn: ptTypeNameEn, updatedBy, updatedAt, status: ptTypeStatus } = objData
    const statusBtnActive = ptTypeStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = ptTypeStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: ptTypeId,
      id: ptTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: ptTypeName },
        { option: 'TEXT', align: 'left', label: ptTypeNameEn },
        { option: 'TEXT', align: 'left', label: objData?.hasCondition === "0" ? 'ไม่มีเงื่อนไข' : objData?.hasCondition === "1" ? 'เงื่อนไขอัตโนมัติตามจำนวนครั้งหัตถการ' : '-' },
        { option: 'STATUS', align: 'center', label: ptTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => {
          loadOperative(objRenderData.obj?.itemTypeId)
          onEdit(objRenderData.obj)
        }}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.patientTypeName)
    setNameEn(obj.patientTypeNameEn)
  }

  return (
    <Box >
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`PATIENT_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message='ประเภทผู้ป่วยนี้ จะถูกลบออกจากผู้ป่วยทั้งหมดในระบบ'
        // message={t(`PATIENT_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { patientTypeName: name, patientTypeNameEn: nameEn && `(${nameEn})`, status: t(`PATIENT_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      >
        <Typography textAlign={'center'} fontSize="14px" fontWeight={400} style={{ whiteSpace: 'pre-line' }}>{t(`PATIENT_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { patientTypeName: name, patientTypeNameEn: nameEn && `(${nameEn})`, status: t(`PATIENT_TYPE.ALERT.${statusAlertModal}`) })}</Typography>

      </AlertModal>
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('PATIENT_TYPE.TITLE')} />
      <Box padding="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('PATIENT_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') },
              ]}
              value={status}
              label={t('STATUS.LABEL')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2} >
            <SelectInput
              onChange={(e) => setConditions(e.target.value)}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: '0', name: 'ไม่มีเงื่อนไข' },
                { value: '1', name: 'เงื่อนไขอัตโนมัติตามจำนวนครั้งหัตถการ' },
              ]}
              label='เงื่อนไขเพิ่มเติม'
              value={conditions}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={6}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <MainButton
                title='ค้นหา'
                type='primary'
                variant='contained'
                onClick={() => {
                  setPage(1)
                  loadData()
                }}
                style={{ width: '120px' }}
              />
              <MainButton
                title={t('PATIENT_TYPE.BUTTON.ADD')}
                type='primary'
                variant='contained'
                onClick={() => {
                  resetForm()
                  setIsPopup(true)
                }}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>

        <Box marginTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={patientTypes.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
      <PageModal
        title={patientTypeId ? t('PATIENT_TYPE.TITLE_UPDATE') : t('PATIENT_TYPE.TITLE_CREATE')}
        isOpen={isPopup}
        onCancel={{ onClick: () => resetForm() }}
        onSubmit={{ onClick: () => patientTypeId ? submitEdit() : submit(), disabled: disabledSubmit }}
        handleClose={resetForm}
        size={'XS'}
      >
        <Box className="py-2">
          {patientTypeId ? (
            <Box component="form" sx={{ mx: 0, mt: 0, mb: '4px', p: 0, display: 'inline-flex', width: '100%' }}>
              <Box component="label" sx={{ mr: 'auto' }}>{t('INPUT.LABEL_STATUS')}</Box>
              <SwitchButton
                onChange={() => setPatientTypeStatus(patientTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                checked={patientTypeStatus === 'ACTIVE' ? true : false}
              />
            </Box>
          ) : (
            ''
          )}

          <Box display={'flex'} flexDirection={'column'} gap={'16px'}>
            <TextInput
              fullWidth
              onChange={(event) => {
                setPatientTypeName(event.target.value)
                clearErrorMessage()
              }}
              value={patientTypeName}
              label={t('PATIENT_TYPE.INPUT.PATIENT_TYPE_NAME')}
              helperText={
                errorMessage.PATIENT_TYPE_NAME ||
                errorMessage.IS_DUPLICATE_PATIENT_TYPE_NAME ||
                errorMessage.PATIENT_TYPE_NAME_STRING_BASE ||
                errorMessage.PATIENT_TYPE_NAME_STRING_EMPTY ||
                errorMessage.PATIENT_TYPE_NAME_MAXIMUM_LENGTH ||
                errorMessage.PATIENT_TYPE_NAME_ANY_REQUIRED
              }
              required={true}
            />
            <TextInput
              fullWidth
              onChange={(event) => {
                setPatientTypeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={patientTypeNameEn}
              helperText={
                errorMessage.PATIENT_TYPE_NAME_EN ||
                errorMessage.IS_DUPLICATE_PATIENT_TYPE_NAME_EN ||
                errorMessage.PATIENT_TYPE_NAME_EN_STRING_BASE ||
                errorMessage.PATIENT_TYPE_NAME_EN_STRING_EMPTY ||
                errorMessage.PATIENT_TYPE_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.PATIENT_TYPE_NAME_EN_ANY_REQUIRED
              }
              label={t('PATIENT_TYPE.INPUT.PATIENT_TYPE_NAME_EN')}
              required={false}
            />
            <Divider className="mx-0 mt-0 mb-1" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
            <SelectInput
              onChange={(e) => {
                setHasCondition(e.target.value)
                setDataOperative('')
                setDataOperativeTypes('')
                setVisitCount('')
              }}
              options={[
                { value: '0', name: 'ไม่มีเงื่อนไข' },
                { value: '1', name: 'เงื่อนไขอัตโนมัติตามจำนวนครั้งหัตถการ' }
              ]}
              label='เงื่อนไขเพิ่มเติม'
              value={hasCondition}
            />
            {hasCondition === "1" &&
              <Box display={'flex'} flexDirection={'column'} gap={'16px'}>
                <SelectInput
                  onChange={(e) => {
                    setDataOperativeTypes(e.target.value)
                    setDataOperative('')
                    loadOperative(Number(e.target.value))
                  }}
                  options={_.map(operativeTypes, (item: any) => ({ value: item.operativeTypeId, name: item.operativeTypeName }))}
                  label='ประเภทหัตถการ'
                  value={dataOperativeTypes}
                  required
                  helperText={errorMessage.OPERATIVE_TYPE && !dataOperativeTypes ? errorMessage.OPERATIVE_TYPE : ''}
                />
                <SelectInput
                  onChange={(e) => setDataOperative(e.target.value)}
                  options={_.map(operative, (item: any) => ({ value: item.operativeId, name: item.operativeName }))}
                  label='รายการหัตถการ'
                  value={dataOperative}
                  required
                  disabled={dataOperativeTypes === ""}
                  helperText={errorMessage.OPERATIVE && !dataOperative ? errorMessage.OPERATIVE : ''}
                />
                <TextInput
                  onChange={(e: any) => {
                    const reg = /[^0-9]/g
                    const value = e.target.value.replace(reg, '')
                    setVisitCount(value === '0' ? '1' : value)
                  }}
                  fullWidth
                  label='จำนวน'
                  required
                  numberOnly
                  value={visitCount}
                  disabled={dataOperativeTypes === ""}
                  helperText={errorMessage.VISITCOUNT && (!visitCount || visitCount === "0" || visitCount === 0) ? errorMessage.VISITCOUNT : ""}
                />
              </Box>
            }
          </Box>
        </Box>
      </PageModal>

    </Box>
  )
}
